export default __webpack_public_path__ + "static/media/crates1.3713bb06.png";